<iframe *ngIf="externalAuthToken" [src]="getIframePath() | safe" style="position: absolute;left: 0;top:0;width: 100%;height: calc(100% - 5rem);">
</iframe>